module.exports = __webpack_public_path__ + "img/SchreitenderI.e611ce9d.jpg";